import { memo } from 'react';

// material-ui
import { styled } from '@mui/material/styles';
import { Avatar, Box, Card, CardContent, Stack, Typography } from '@mui/material';

// assets
import IconKeyboard from '@mui/icons-material/KeyboardAltOutlined';

// styles
const CardStyle = styled(Card)(() => ({
    marginBottom: '22px',
    overflow: 'hidden',
    position: 'relative',
    borderRadius: '18px',
    border: '1px solid rgba(255,255,255,0.35)',
    backgroundImage: 'linear-gradient(135deg, #7c4dff 0%, #536dfe 55%, #00b0ff 100%)',
    boxShadow: '0 12px 30px rgba(83,109,254,0.35)',
    '&:before': {
        content: '""',
        position: 'absolute',
        width: '150px',
        height: '150px',
        background: 'rgba(255,255,255,0.16)',
        borderRadius: '50%',
        top: '-70px',
        right: '-50px'
    },
    '&:after': {
        content: '""',
        position: 'absolute',
        width: '90px',
        height: '90px',
        background: 'rgba(255,255,255,0.12)',
        borderRadius: '50%',
        bottom: '-40px',
        left: '-20px'
    }
}));

// ==============================|| SIDEBAR - MENU CARD ||============================== //

const MenuCard = () => (
    <CardStyle>
        <CardContent sx={{ p: 2.5, position: 'relative', zIndex: 1 }}>
            <Stack direction="row" spacing={1.5} alignItems="center">
                <Avatar
                    variant="rounded"
                    sx={{
                        bgcolor: 'rgba(255,255,255,0.22)',
                        color: '#fff',
                        width: 44,
                        height: 44,
                        borderRadius: '12px'
                    }}
                >
                    <IconKeyboard />
                </Avatar>
                <Box>
                    <Typography variant="subtitle1" sx={{ color: '#fff', fontWeight: 700, lineHeight: 1.2 }}>
                        SmartTyping Admin
                    </Typography>
                    <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.85)' }}>
                        ศูนย์ควบคุมระบบพิมพ์สัมผัส
                    </Typography>
                </Box>
            </Stack>
            <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.9)', display: 'block', mt: 2 }}>
                จัดการคอร์ส นักเรียน และโรงเรียนได้จากที่เดียว
            </Typography>
        </CardContent>
    </CardStyle>
);

export default memo(MenuCard);
